export const APP_KEY = '';
export const APP_SCOPES = 'read_products';
export const APP_TITLE = 'CF Starter'